export default {
    locales: {
        de: 'German',
        en: 'English'
    },
    title: 'Language'
}
